import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22variable%22:%22--font-body%22,%22src%22:[{%22path%22:%22./Passport.otf%22,%22weight%22:%22400%22}]}],%22variableName%22:%22body%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'body', 'body Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
